document.addEventListener("DOMContentLoaded", function () {
  // Tab切换
  const tabContainers = document.querySelectorAll(".product-tabs");
  tabContainers.forEach((tabContainer) => {
    const tabs = tabContainer.querySelectorAll(".product-tab");
    tabs.forEach((tab, idx) => {
      tab.addEventListener("click", () => {
        tabs.forEach((t) => t.classList.remove("active"));
        tab.classList.add("active");
        tab.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
        // 切换内容
        const tabPlanes =
          tabContainer.parentElement.querySelectorAll(".tab-plane-item");
        tabPlanes.forEach((plane, i) => {
          plane.style.display = i === idx ? "block" : "none";
        });
        // 重置当前tab下的滚动条到最左侧，并重置按钮和卡片状态
        const currentPlane = tabPlanes[idx];
        const scrollList = currentPlane.querySelector(
          ".product-list.scrollable"
        );
        if (scrollList) {
          scrollList.scrollTo({ left: 0, behavior: "auto" });
          scrollList._currentIndex = 0; // 重置currentIndex
          // 重置按钮和卡片状态
          const arrows = currentPlane.querySelector(".product-list-arrows");
          const leftBtn = arrows
            ? arrows.querySelector(".product-list-arrow:first-child")
            : null;
          const rightBtn = arrows
            ? arrows.querySelector(".product-list-arrow:last-child")
            : null;
          const cards = scrollList.querySelectorAll(".product-card");
          // 动态计算perPage
          const perPage = getPerPage(scrollList);
          // 卡片状态
          cards.forEach((card, idx2) => {
            if (idx2 < perPage) {
              card.classList.remove("outside");
            } else {
              card.classList.add("outside");
            }
            // 还原样式
            card.style.opacity = "";
            card.style.transform = "";
            card.style.zIndex = "";
          });
          // 按钮状态
          if (leftBtn) leftBtn.disabled = true;
          if (rightBtn) rightBtn.disabled = cards.length <= perPage;
          // at-end类移除
          scrollList.classList.remove("at-end");
          // 重新执行updateCards，保证一切状态同步
          if (typeof scrollList._updateCards === "function") {
            scrollList._updateCards();
          }
        }
      });
    });
  });

  // 动态获取卡片宽度+间隙
  function getCardWidthWithGap(list) {
    const card = list.querySelector(".product-card");
    if (!card) return 0;
    const style = window.getComputedStyle(card);
    const cardWidth = card.getBoundingClientRect().width;
    // 尝试获取 margin-right
    const gap = parseFloat(style.marginRight) || 0;
    // 如果用的是 flex/grid gap
    const parentGap = parseFloat(window.getComputedStyle(list).columnGap) || 0;
    // 取最大值（哪个有用取哪个）
    return cardWidth + Math.max(gap, parentGap);
  }
  // 动态获取每页可见卡片数
  function getPerPage(list) {
    const listRect = list.getBoundingClientRect();
    const style = getComputedStyle(list);
    const paddingLeft = parseFloat(style.paddingLeft);
    const paddingRight = parseFloat(style.paddingRight);
    const cardWidth = getCardWidthWithGap(list);
    if (!cardWidth) return 1;
    return Math.floor(
      (listRect.width -
        paddingLeft -
        paddingRight +
        (parseFloat(style.columnGap) || 0) +
        1) / // +1像素容错
        cardWidth
    );
  }

  // 产品列表渲染
  function renderProductLists() {
    document.querySelectorAll(".tab-plane-item").forEach((tabPlane) => {
      const list = tabPlane.querySelector(".product-list");
      if (!list) return;
      const cards = list.querySelectorAll(".product-card");
      const count = cards.length;
      const isMobile =
        window.innerWidth < 768 || document.documentElement.clientWidth < 768;
      if (isMobile) {
        // 先移除
        list.classList.remove("single");
        list.classList.remove("grid");
        list.classList.remove("container");
        // 移动端：无论多少都 scrollable
        {
          list.classList.add("scrollable");
          list.classList.add("scrollbarHide");
          list._currentIndex = 0;

          // 先移除已有的箭头，保证只存在一个
          tabPlane
            .querySelectorAll(".product-list-arrows")
            .forEach((el) => el.remove());

          // 箭头按钮
          const arrows = document.createElement("div");
          arrows.className = "product-list-arrows container";
          const leftBtn = document.createElement("button");
          leftBtn.className = "product-list-arrow";
          leftBtn.innerHTML = `
<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.8947 0C5.2851 0.390998 5.2851 1.02493 4.8947 1.41593L1.3161 5L4.8947 8.58407C5.2851 8.97507 5.2851 9.609 4.8947 10L0.255775 5.35398C0.0605749 5.15848 0.0605749 4.84152 0.255775 4.64602L4.8947 0Z" fill="black"/>
</svg>
`;
          leftBtn.disabled = true;
          const rightBtn = document.createElement("button");
          rightBtn.className = "product-list-arrow";
          rightBtn.innerHTML = `
<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.1053 10C0.7149 9.609 0.7149 8.97507 1.1053 8.58407L4.6839 5L1.1053 1.41593C0.7149 1.02493 0.7149 0.390998 1.1053 0L5.74422 4.64602C5.93943 4.84152 5.93943 5.15848 5.74422 5.35398L1.1053 10Z" fill="black"/>
</svg>
`;
          arrows.appendChild(leftBtn);
          arrows.appendChild(rightBtn);
          if (count !== 1) {
            tabPlane.appendChild(arrows);
          }

          function updateCards() {
            const currentIndex = list._currentIndex || 0;
            const perPage = getPerPage(list);
            const cardWidth = getCardWidthWithGap(list);
            const maxIndex = Math.max(0, count - perPage);
            const centerStart = currentIndex;
            const centerEnd = centerStart + perPage;
            cards.forEach((card, idx) => {
              if (idx >= centerStart && idx < centerEnd) {
                card.classList.remove("outside");
              } else {
                card.classList.add("outside");
              }
            });
            leftBtn.disabled = currentIndex === 0;
            rightBtn.disabled = currentIndex >= maxIndex;
            if (currentIndex >= maxIndex) {
              list.classList.add("at-end");
            } else {
              list.classList.remove("at-end");
            }
          }
          // 让外部可调用
          list._updateCards = updateCards;

          function scrollToIndex(idx) {
            const cardWidthWithGap = getCardWidthWithGap(list);
            const maxIndex = Math.max(0, count - 1); // 只要不超出最后一个
            let targetIdx = Math.min(idx, maxIndex);
            list._currentIndex = targetIdx;
            const scrollLeft = targetIdx * cardWidthWithGap;
            list.scrollTo({ left: scrollLeft, behavior: "smooth" });
            updateCards();
          }

          leftBtn.addEventListener("click", function () {
            if ((list._currentIndex || 0) > 0)
              scrollToIndex((list._currentIndex || 0) - 1);
          });
          rightBtn.addEventListener("click", function () {
            if ((list._currentIndex || 0) < count - 1)
              scrollToIndex((list._currentIndex || 0) + 1);
          });

          // hover效果：鼠标移入透明卡片时，透明度100%且放大
          cards.forEach((card) => {
            card.addEventListener("mouseenter", function () {
              if (card.classList.contains("outside")) {
                card.style.opacity = "1";
                card.style.transform = "scale(1.03)";
                card.style.zIndex = "2";
              }
            });
            card.addEventListener("mouseleave", function () {
              if (card.classList.contains("outside")) {
                card.style.opacity = "";
                card.style.transform = "";
                card.style.zIndex = "";
              }
            });
          });

          // 新增：监听滚动事件，实时更新按钮和卡片状态
          list.addEventListener("scroll", function () {
            const cardWidth = getCardWidthWithGap(list);
            if (!cardWidth) return;
            const newIndex = Math.round(list.scrollLeft / cardWidth);
            if (list._currentIndex !== newIndex) {
              list._currentIndex = newIndex;
              if (typeof list._updateCards === "function") {
                list._updateCards();
              }
            }
          });

          // 初始化
          updateCards();
          setTimeout(updateCards, 50);
          // 图片加载后再刷新一次
          const img = list.querySelector("img");
          if (img) {
            img.addEventListener("load", function () {
              updateCards();
            });
          }
        }
      } else {
        // PC端按原有逻辑
        if (count === 1) {
          tabPlane
            .querySelectorAll(".product-list-arrows")
            .forEach((el) => el.remove());
          list.classList.remove("scrollable");
          list.classList.add("single");
          list.classList.add("container");
        } else if (count > 1 && count <= 4) {
          tabPlane
            .querySelectorAll(".product-list-arrows")
            .forEach((el) => el.remove());
          list.classList.remove("scrollable");
          list.classList.add("grid");
          list.classList.add("container");
        } else if (count > 4) {
          {
            list.classList.add("scrollable");
            list.classList.add("scrollbarHide");
            list._currentIndex = 0;

            // 先移除已有的箭头，保证只存在一个
            tabPlane
              .querySelectorAll(".product-list-arrows")
              .forEach((el) => el.remove());

            // 箭头按钮
            const arrows = document.createElement("div");
            arrows.className = "product-list-arrows container";
            const leftBtn = document.createElement("button");
            leftBtn.className = "product-list-arrow";
            leftBtn.innerHTML = `
<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.8947 0C5.2851 0.390998 5.2851 1.02493 4.8947 1.41593L1.3161 5L4.8947 8.58407C5.2851 8.97507 5.2851 9.609 4.8947 10L0.255775 5.35398C0.0605749 5.15848 0.0605749 4.84152 0.255775 4.64602L4.8947 0Z" fill="black"/>
</svg>
`;
            leftBtn.disabled = true;
            const rightBtn = document.createElement("button");
            rightBtn.className = "product-list-arrow";
            rightBtn.innerHTML = `
<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.1053 10C0.7149 9.609 0.7149 8.97507 1.1053 8.58407L4.6839 5L1.1053 1.41593C0.7149 1.02493 0.7149 0.390998 1.1053 0L5.74422 4.64602C5.93943 4.84152 5.93943 5.15848 5.74422 5.35398L1.1053 10Z" fill="black"/>
</svg>
`;
            arrows.appendChild(leftBtn);
            arrows.appendChild(rightBtn);
            tabPlane.appendChild(arrows);

            function updateCards() {
              const currentIndex = list._currentIndex || 0;
              const perPage = getPerPage(list);
              const cardWidth = getCardWidthWithGap(list);
              const maxIndex = Math.max(0, count - perPage);
              const centerStart = currentIndex;
              const centerEnd = centerStart + perPage;
              cards.forEach((card, idx) => {
                if (idx >= centerStart && idx < centerEnd) {
                  card.classList.remove("outside");
                } else {
                  card.classList.add("outside");
                }
              });
              leftBtn.disabled = currentIndex === 0;
              rightBtn.disabled = currentIndex >= maxIndex;
              if (currentIndex >= maxIndex) {
                list.classList.add("at-end");
              } else {
                list.classList.remove("at-end");
              }
            }
            // 让外部可调用
            list._updateCards = updateCards;

            function scrollToIndex(idx) {
              const cardWidthWithGap = getCardWidthWithGap(list);
              const maxIndex = Math.max(0, count - 1); // 只要不超出最后一个
              let targetIdx = Math.min(idx, maxIndex);
              list._currentIndex = targetIdx;
              const scrollLeft = targetIdx * cardWidthWithGap;
              list.scrollTo({ left: scrollLeft, behavior: "smooth" });
              updateCards();
            }

            leftBtn.addEventListener("click", function () {
              if ((list._currentIndex || 0) > 0)
                scrollToIndex((list._currentIndex || 0) - 1);
            });
            rightBtn.addEventListener("click", function () {
              if ((list._currentIndex || 0) < count - 1)
                scrollToIndex((list._currentIndex || 0) + 1);
            });

            // hover效果：鼠标移入透明卡片时，透明度100%且放大
            cards.forEach((card) => {
              card.addEventListener("mouseenter", function () {
                if (card.classList.contains("outside")) {
                  card.style.opacity = "1";
                  card.style.transform = "scale(1.03)";
                  card.style.zIndex = "2";
                }
              });
              card.addEventListener("mouseleave", function () {
                if (card.classList.contains("outside")) {
                  card.style.opacity = "";
                  card.style.transform = "";
                  card.style.zIndex = "";
                }
              });
            });

            // 新增：监听滚动事件，实时更新按钮和卡片状态
            list.addEventListener("scroll", function () {
              const cardWidth = getCardWidthWithGap(list);
              if (!cardWidth) return;
              const newIndex = Math.round(list.scrollLeft / cardWidth);
              if (list._currentIndex !== newIndex) {
                list._currentIndex = newIndex;
                if (typeof list._updateCards === "function") {
                  list._updateCards();
                }
              }
            });

            // 初始化
            updateCards();
            setTimeout(updateCards, 50);
            // 图片加载后再刷新一次
            const img = list.querySelector("img");
            if (img) {
              img.addEventListener("load", function () {
                updateCards();
              });
            }
          }
        }
      }
    });
  }

  // 动态设置滚动区两侧padding，保证内容居中且最大宽度不超过1200px
  function setProductListSidePadding() {
    const maxContentWidth = 1200;
    var winWidth = document.documentElement.clientWidth;
    let sidePadding = (winWidth - Math.min(winWidth, maxContentWidth)) / 2;
    if (sidePadding < 40) sidePadding = 24;
    document.querySelectorAll(".product-list.scrollable").forEach((list) => {
      list.style.setProperty("--product-list-side-padding", sidePadding + "px");
    });
  }

  window.addEventListener("DOMContentLoaded", () => {
    setProductListSidePadding();
    renderProductLists();
  });
  window.addEventListener("resize", setProductListSidePadding);
  window.addEventListener("resize", renderProductLists);

  // 全局刷新：页面load和resize时刷新所有滚动区
  window.addEventListener("load", function () {
    document.querySelectorAll(".product-list.scrollable").forEach((list) => {
      if (typeof list._updateCards === "function") list._updateCards();
    });
  });
  window.addEventListener("resize", function () {
    document.querySelectorAll(".product-list.scrollable").forEach((list) => {
      if (typeof list._updateCards === "function") list._updateCards();
    });
  });
});
